export default "__VITE_ASSET__dc69f8b0__"